"use strict";

var ubian = ubian || { };

ubian.safe_id = {
    showPrompt: function () {
        var dialog = ubian.utils.alert(ubian.translate('JS.Error.SafeID.Required'), null, ubian.translate('Button.Login'));
        var btn = $(dialog).find('.btn-green');
        btn.attr('href', ubian.routes['safeid_request'] + '?from=card_add');
        btn.removeAttr('data-dismiss');
    },
    displayError: function () {
        var params = new URLSearchParams(window.location.search);
        var error = params.get('safeid_error');
        if (!error) {
            return;
        }
        var key = 'JS.Error.SafeID.VerificationFail.Text.' + error;
        var translation = ubian.translate(key);
        if (translation === key) {
            translation = ubian.translate('JS.Error.SafeID.VerificationFail.Text.Generic');
        }
        var dialog = ubian.utils.alert('<strong>' + ubian.translate('JS.Error.SafeID.VerificationFail.Title') + '</strong><br /><br />' + translation, null, ubian.translate('JS.Error.SafeID.VerificationFail.Button'), function () {
            window.location.search = '';
        });
        var btn = $(dialog).find('.btn-green');
        btn.attr('href', ubian.routes['safeid_request'] + '?from=' + params.get('from'));
        btn.removeAttr('data-dismiss');
    }
};

$(ubian.safe_id.displayError);
